import { cn } from '@/lib/utils';

function Skeleton({ className, style, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md', className)}
      style={{ background: 'var(--gray-100)', ...style }}
      {...props}
    />
  );
}

export { Skeleton };
